<template>
  <v-app>
    <!-- <NavBar/> -->
    <div class="v-main__wrap kiosk-shell" :style="{ backgroundImage: `url(${bgImage})` }">
   
      <v-main>
        <div>
          <router-view />
        </div>
      </v-main>
    </div>
  </v-app>
</template>

<script>
// import NavBar from "./components/NavBar";
export default {
  name: "App",
  components: {
    // NavBar,
  },
  data() {
    return {
      bgImage: require('@/assets/BG-OB.jpg'),
      bgImagelogo: require('@/assets/logo-01.png'), // หรือใช้ import.meta.url สำหรับ Vite
    }
  },
};
</script>

<style>
@font-face {
  font-family: "Kanit";
  src: local("Kanit"), url(./assets/Font/Kanit-Regular.ttf);
}


.box {
  color: white;
  padding: 15px;
  text-align: center;
  width: 350px;
  clip-path: none;
  border-radius: 999px;
}

.folded-corner {
  
  color: white;             /* สีตัวอักษร */
  padding: 15px;            /* ระยะห่างภายใน */
  text-align: center;       /* จัดข้อความกึ่งกลาง */
  width: 350px;             /* ความกว้าง */

  /* --- หัวใจสำคัญคือบรรทัดนี้ --- */
  clip-path: polygon(
    100px 0,      /* จุดที่ 1: เริ่มจากมุมบน แต่ขยับขวามา 25px */
    100% 0,      /* จุดที่ 2: ไปที่มุมบนขวา */
    100% calc(100% - 100px), /* จุดที่ 3: ลงมาที่ขอบล่าง แต่เว้นระยะจากมุม 25px */
    calc(100% - 0px) 100%,/* จุดที่ 4: ไปที่มุมล่าง แต่ขยับซ้ายมา 25px */
    0 100%,      /* จุดที่ 5: ไปที่มุมล่างซ้าย */
    0 100px       /* จุดที่ 6: กลับขึ้นไปที่ขอบบน แต่เว้นระยะจากมุม 25px */
  );
}

/* .folded-corner {
  position: relative;
  background-color: #ffffff;
  color: white;
  border-radius: 0;
  padding: 20px;
  overflow: hidden;
}

.folded-corner::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-top: 60px solid #344054;
  border-left: 60px solid transparent;
} */

.v-main__wrap {
  background-size: cover;
  background-position: center;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.v-main__wrap::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0.66) 34%, rgba(255, 255, 255, 0.14) 72%),
    linear-gradient(180deg, rgba(52, 64, 84, 0.1) 0%, rgba(31, 41, 55, 0.18) 100%);
  pointer-events: none;
}

.kiosk-shell .v-main {
  position: relative;
  z-index: 1;
  height: 100vh;
}

.kiosk-shell .v-main > div,
.kiosk-shell .v-main > div > div {
  min-height: 100vh;
}

.kiosk-shell .row {
  margin: 0;
}

.kiosk-shell .col,
.kiosk-shell [class*="col-"] {
  padding: 0;
}

.kiosk-shell .app.v-image {
  width: min(34vw, 520px) !important;
  max-width: min(34vw, 520px) !important;
  margin: clamp(18px, 3vh, 36px) auto 0 !important;
  filter: drop-shadow(0 16px 28px rgba(0, 53, 78, 0.14));
}

.kiosk-shell .folded-corner {
  width: min(1180px, calc(100vw - 96px)) !important;
  height: auto !important;
  min-height: min(70vh, 680px);
  max-height: calc(100vh - 116px);
  margin: clamp(18px, 4vh, 44px) auto 0 !important;
  padding: clamp(22px, 3vw, 42px) !important;
  overflow: hidden;
  color: #1f2937;
  background: rgba(255, 255, 255, 0.96) !important;
  box-shadow: 0 28px 70px rgba(16, 24, 40, 0.18);
  backdrop-filter: blur(10px);
}

.kiosk-shell .folded-corner > .container {
  max-width: 100%;
  height: 100%;
  padding: 0;
}

.kiosk-shell .folded-corner .v-card:not(#capture):not(#scroll-target):not(.box) {
  width: 100% !important;
  height: auto !important;
  min-height: 0;
  max-height: calc(100vh - 180px);
  overflow: hidden;
  background-color: transparent !important;
}

.kiosk-shell .folded-corner .v-divider {
  border-radius: 999px;
}

.kiosk-shell .folded-corner .row[style*="margin-top"] {
  margin-top: clamp(14px, 2.4vh, 28px) !important;
}

.kiosk-shell .box {
  position: relative;
  width: min(420px, 100%) !important;
  min-height: 88px;
  padding: 12px 22px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  isolation: isolate;
  border-radius: 999px !important;
  border: 1px solid rgba(255, 255, 255, 0.46);
  clip-path: none !important;
  background:
    radial-gradient(125% 95% at 50% -42%, rgba(255, 255, 255, 0.54) 0%, rgba(255, 255, 255, 0.18) 36%, transparent 60%),
    linear-gradient(180deg, #6b788c 0%, #465468 34%, #2b374b 66%, #151e31 100%) !important;
  transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;
  box-shadow:
    0 28px 42px rgba(16, 24, 40, 0.3),
    0 10px 0 #0f172a,
    0 13px 0 rgba(15, 23, 42, 0.12),
    inset 0 4px 0 rgba(255, 255, 255, 0.32),
    inset 0 -10px 16px rgba(0, 0, 0, 0.28),
    inset 0 0 0 2px rgba(255, 255, 255, 0.08);
}

.kiosk-shell .box::before {
  content: "";
  position: absolute;
  top: 9px;
  left: 24px;
  right: 24px;
  height: 42%;
  border-radius: 999px 999px 48px 48px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.24), rgba(255, 255, 255, 0.04) 75%, transparent);
  opacity: 0.88;
  mix-blend-mode: screen;
  pointer-events: none;
  z-index: 0;
}

.kiosk-shell .box::after {
  content: "";
  position: absolute;
  top: 8px;
  right: 18px;
  width: 50px;
  height: calc(100% - 16px);
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.03));
  box-shadow:
    inset 5px 0 10px rgba(255, 255, 255, 0.05),
    inset -8px 0 12px rgba(0, 0, 0, 0.18);
  opacity: 0.62;
  transform: skewX(-14deg);
  pointer-events: none;
  z-index: 0;
}

.kiosk-shell .box:hover {
  transform: translateY(-2px);
  filter: brightness(1.04);
  box-shadow:
    0 32px 48px rgba(16, 24, 40, 0.32),
    0 10px 0 #0f172a,
    0 15px 0 rgba(15, 23, 42, 0.12),
    inset 0 4px 0 rgba(255, 255, 255, 0.36),
    inset 0 -9px 15px rgba(0, 0, 0, 0.26),
    inset 0 0 0 2px rgba(255, 255, 255, 0.1);
}

.kiosk-shell .box:active {
  transform: translateY(4px);
  box-shadow:
    0 12px 22px rgba(16, 24, 40, 0.22),
    0 4px 0 #0f172a,
    0 6px 0 rgba(15, 23, 42, 0.1),
    inset 0 4px 12px rgba(0, 0, 0, 0.3);
}

.kiosk-shell .box > *,
.kiosk-shell .v-btn.box .v-btn__content {
  position: relative;
  z-index: 1;
}

.kiosk-shell .v-btn.box {
  display: inline-flex;
}

.kiosk-shell .v-btn.box .v-btn__content {
  white-space: normal;
  line-height: 1.15;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.32);
}

.kiosk-shell .v-btn.box.v-btn--disabled,
.kiosk-shell .box.v-btn--disabled {
  opacity: 0.58;
  filter: grayscale(0.2);
  box-shadow:
    0 14px 24px rgba(16, 24, 40, 0.18),
    0 5px 0 #1f2937,
    inset 0 2px 0 rgba(255, 255, 255, 0.16),
    inset 0 -6px 12px rgba(0, 0, 0, 0.18);
}

.kiosk-shell .camera-container {
  width: min(48vw, 720px) !important;
  height: min(45vh, 480px) !important;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 18px 40px rgba(16, 24, 40, 0.18);
}

.kiosk-shell .v-input input {
  font-size: clamp(28px, 3vw, 42px) !important;
}

.kiosk-shell #scroll-target {
  width: min(920px, calc(100vw - 220px)) !important;
  height: min(48vh, 650px) !important;
  background-color: #ffffff !important;
}

@media only screen and (max-width: 959px) {
  .v-main__wrap {
    background-size: cover;
    background-position: center;
    width: 100vw;
    height: 100vh;
  }
}

@media (orientation: portrait) {
  .kiosk-shell .folded-corner {
    width: min(940px, calc(100vw - 48px)) !important;
    max-height: calc(100vh - 130px);
  }

  .kiosk-shell .app.v-image {
    width: min(58vw, 520px) !important;
    max-width: min(58vw, 520px) !important;
  }
}

#app {
  font-family: "Kanit";
  color: #444444;
  scrollbar-width: none;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  overscroll-behavior: none;
  touch-action: manipulation;
  -ms-touch-action: manipulation;
  -webkit-text-size-adjust: 100%;
  user-select: none;
}

@-moz-document url-prefix() {

  /* Disable scrollbar Firefox */
  html {
    scrollbar-width: none;
  }
}


.loading-box {
  width: 250px !important;
  height: 150px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 150px;
  height: 90px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.rect {
  background: #f1f1f1;
  display: inline-block;
  height: 90px;
  width: 12px;
  margin: 0 1px;
  animation: load 1.3s infinite ease-in-out;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

::-webkit-scrollbar {
  display: none;
}
</style>
